import { AICredits } from '@/types/ai-assistant'

export type DocumentsAISummaryState = {
  documentToSummarize: object | null
  requestSummaryPending: boolean
  summariesCredits: AICredits | null
  summariesCreditsPending: boolean
}

export const state: DocumentsAISummaryState = {
  documentToSummarize: null,
  requestSummaryPending: false,
  summariesCredits: null,
  summariesCreditsPending: false,
}
